<div class="container" style="padding: 2rem">
  <h1>Version Information</h1>

  <div style="margin-top: 2rem" *ngIf="!isLoading">
    <div class="section">
      <h2>Frontend</h2>
      <p><strong>Version:</strong> {{ frontendVersion }}</p>
      <p><strong>Build Date:</strong> {{ frontendBuildDate }}</p>
    </div>

    <div class="section">
      <h2>Backend</h2>
      <p><strong>Version:</strong> {{ backendVersion }}</p>
      <p><strong>Name:</strong> {{ backendName }}</p>
      <p><strong>Description:</strong> {{ backendDescription }}</p>
      <p><strong>Build Date:</strong> {{ backendBuildDate }}</p>
    </div>
  </div>

  <div *ngIf="isLoading">
    <p>Loading...</p>
  </div>
</div>
